export const parseQueryString = (queryString = '') => {
    // Convert '?foo=1&bar=3' to {foo: 1, bar: 3}
    if (!queryString || queryString === '') {
        return {};
    }

    if (queryString.startsWith('?')) {
        queryString = queryString.substring(1, queryString.length);
    }

    const data = {};
    queryString
        .split('&')
        .map(pair => decodeURI(pair).split('='))
        .forEach(([key, value]) => (data[key] = value));
    return data;
};

// we have a problem with options being *already* urlencoding and then getting
// double-encoded, so: we always decode then reencode. 2x the inefficiency, 2x the fun!
// A value that isn't valid encoding (e.g. a typed '50%') is encoded as-is.
const safeDecode = value => {
    try {
        return decodeURIComponent(value);
    } catch (e) {
        if (e instanceof URIError) {
            return value;
        }
        throw e;
    }
};

export const urlEncode = value => encodeURIComponent(safeDecode(value));

export const toQueryString = (params = {}) => {
    // {foo: 1, bar: 2} => 'foo=1&bar=2'
    return Object.keys(params)
        .filter(key => params[key] !== undefined && params[key] !== null)
        .map(function(key) {
            return [key, params[key]].map(urlEncode).join('=');
        })
        .join('&');
};

export const updateQueryString = (queryString = '', newParams) => {
    return toQueryString({
        ...parseQueryString(queryString),
        ...newParams,
    });
};

export const stripLocalHostname = url => {
    // Because we want to pass urls as 'to=' arg to a Link but our API returns
    // the full URL with hostname, if it is an internal link, we need to strip
    // the domain...but only if its an internal link.
    let urlObj = null;
    try {
        urlObj = new URL(url);
    } catch (e) {
        return url;
    }

    if (urlObj.hostname === window.location.hostname) {
        return urlObj.pathname;
    }

    return url;
};

export const splitUrl = url => {
    const [domain, querystring = ''] = url.split('?');

    return {
        domain: domain,
        search: querystring,
        searchParams: parseQueryString(querystring),
    };
};

export const updateParams = (url = '', updates = {}) => {
    const { domain, searchParams } = splitUrl(url);
    const params = toQueryString({ ...searchParams, ...updates });
    return params ? `${domain}?${params}` : domain;
};
